import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CalendarIcon } from 'lucide-react';
export function AppointmentCTA() {
  return <section className="py-32 bg-schwarz relative overflow-hidden" data-id="element-18">
      {/* Decorative background circle */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] border border-weiss/5 rounded-full pointer-events-none" data-id="element-19" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-weiss/10 rounded-full pointer-events-none" data-id="element-20" />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-21">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-5xl md:text-6xl font-heading text-weiss mb-8" data-id="element-22">
          Vereinbaren Sie Ihren Termin
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-xl text-sand font-body mb-12 max-w-2xl mx-auto" data-id="element-23">
          Unser Team ist für alle Patienten und Patientinnen, auch aus Fürth und
          Erlangen, mit schnellen Terminen da.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-24">
          <Link to="/kontakt" data-id="element-25">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="flex items-center space-x-3 bg-royal-blue text-weiss px-10 py-5 rounded-full text-lg font-heading shadow-[0_0_30px_rgba(27,42,74,0.3)] hover:shadow-[0_0_40px_rgba(212,175,55,0.2)] transition-all border border-transparent hover:border-gold" data-id="element-26">
              <CalendarIcon className="w-5 h-5" data-id="element-27" />
              <span data-id="element-28">Termin vereinbaren</span>
            </motion.button>
          </Link>

          <span className="text-warm-gray font-body" data-id="element-29">oder</span>

          <a href="tel:091156836360" className="text-xl text-weiss hover:text-gold transition-colors font-heading" data-id="element-30">
            0911-56 83 63 60
          </a>
        </motion.div>
      </div>
    </section>;
}